module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scroll",
    staticClass: "slider"
  }, [_c('div', {
    ref: "content",
    staticClass: "slider-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-642fb7d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/slider.vue
// module id = 258
// module chunks = 22